module.exports = __webpack_public_path__ + "grootstatic/media/essar.9e6db2fb.svg";